import { useState, Suspense } from 'react';
import { Spin } from 'antd';
import styles from './index.less';
import { pdfjs } from 'react-pdf';
import { Document, Page } from '@/components/react-pdf-lazy';

type PdfViewProps = {
  url: string; // pdf连接
};

pdfjs.GlobalWorkerOptions.workerSrc = `//static.huolala.cn/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export default function Pdfview(props: PdfViewProps) {
  const [error, setError] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const { url } = props;

  if (error) {
    console.log('pdf加载失败');
  }

  if (!url) {
    return <div>加载中...</div>;
  }

  return (
    <div className={styles['pdf-view-wrap']}>
      <Suspense fallback={<Spin />}>
        <Document
          className={styles.document}
          file={url}
          onLoadSuccess={({ numPages }) => {
            setPageNumber(numPages);
          }} // 加载失败调用
          loading={'加载中...'}
          onLoadError={(e) => {
            setError(true);
            console.log('加载PDF错误', [
              '协议页面',
              e.name,
              e.message,
              e.stack?.toString() ?? '',
            ]);
          }}
          onSourceError={(e) => {
            console.log('加载PDF错误', [
              '协议页面',
              e.name,
              e.message,
              e.stack?.toString() ?? '',
              'onSourceError',
            ]);
          }}
        >
          {Array.from(new Array(pageNumber), (_, index) => (
            <Page
              renderTextLayer={false}
              renderAnnotationLayer={false}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={window.innerWidth}
              loading={'加载中...'}
            />
          ))}
        </Document>
      </Suspense>
    </div>
  );
}
